import { call, put, fork } from 'redux-saga/effects'
import firebase from 'firebase/app'
import MerchantActions from '../reducers/restaurantReducer'

const MERCHANT_NOTE = 'MERCHANT_NOTE'
const Storage = window.localStorage

function* getLatestNote(merchantKey) {
  try {
    const ref = firebase.database().ref(`restaurants/${merchantKey}/note`)
    const snapshot = yield call([ref, ref.once], 'value')
    const note = snapshot.val() || ''

    yield put(MerchantActions.setMerchantNote(merchantKey, note))
    yield call([Storage, Storage.setItem], `${MERCHANT_NOTE}_merchantKey`, note)
  } catch (error) {
    console.error(error)
  }
}

export function* getMerchantNote({ merchantKey }) {
  try {
    const cache = yield call([Storage, Storage.getItem], `${MERCHANT_NOTE}_merchantKey`)

    if (cache) yield put(MerchantActions.setMerchantNote(merchantKey, cache))

    yield fork(getLatestNote, merchantKey)
  } catch (error) {
    //
    console.error(error)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/merchantSagas.js